// Determined by useAppStartupBrowserAuthSession; acted on by useWebAuthFlow.
enum BrowserAuthStatus {
  // credentials exist but are unusable (revoked/renew failed), or
  // the SDK surfaced an unrecoverable error (e.g. missing_transaction).
  // either way, a /v2/logout round-trip is required
  Expired = "expired",
  // Auth0 SDK has a stored user AND stored credentials pass our validation checks
  LoggedIn = "logged-in",
  // no user session at all — proceed to fresh login.
  LoggedOut = "logged-out",
}

export { BrowserAuthStatus };
